<template> 
     <BaseModal
        :id="'static-template'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_simulated()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />

                <hr/>
                    <div class="modal__description">
                        <p class="modal__description__text" v-html="'By default, the system will omit rooms inspected within the last 30 days. Use the field below adjust the default amount of days to exclude previously inspected rooms from Multiple Room Inspection search results.'"/> 
                    </div>
                    
                    <div class="row m-0 formdynamic">
                        <div class="custom-control px-0">
                            <input 
                                type="radio" 
                                class="custom-radio"
                                id="2yes"
                                style="display: inline"
                                :value="false"
                                v-model="form_data.exclude_rooms"
                            />
                            <label
                            :class="'form-check-label radiobutton__text'" v-html="`Don't exclude rooms`"
                            style="font-size: 0.9rem"
                                for="2yes"
                            />
                        </div>
                    </div>
                    <div class="row m-0 formdynamic justify-content-md-between" :style="`padding-top: 0px;`">
                        <div :class="'col-md-12'" class="p-0 formdynamic__item" :style="`margin-top:10px`">
                            <div class="formdynamic__item__field" style="display: inline-flex;">
                                <input 
                                type="radio" 
                                class="custom-radio"
                                id="2yes"
                                style="display: inline"
                                :value="true"
                                v-model="form_data.exclude_rooms"
                                />
                                <label
                                :class="'form-check-label radiobutton__text'"
                                style="font-size: 0.9rem"
                                    for="2yes"
                                />
                                <label class="modal-label input-date-template mt-0" v-html="`Exclude rooms inspected in last`" style="margin-right:5px; font-weight:normal;" />
                                <input 
                                    :type="`number`"
                                    :required="true"
                                    v-model="form_data.omission_setting"
                                    :style="`width:20px; height: 18px;`"
                                    class="mt-0"
                                    :disabled="!form_data.exclude_rooms"
                                />
                                <label class="modal-label input-date-template mt-0" v-html="`days.`" style="margin-left:5px; font-weight:normal;"/>
                            </div>
                        </div>
                    </div>

                    <div class="row m-0">
                        <button class="modal__buttons__item mt-3 ml-auto" v-html="'Search rooms'" type="button" @click="filtering_data()" style="height:34px;"/>
                    </div>
                <hr/>
                
                <div class="room__collapse accordion" id="accordionExample" style="margin-top:10px;">
                    <div class="card">
                        <div class="card-header p-0" id="headingOne">
                            <button class="room__collapse__header" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                Advanced Search
                                <svg xmlns="http://www.w3.org/2000/svg" width="9.414" height="5.414" viewBox="0 0 9.414 5.414" class="arrow__collapsible">
                                <g id="Grupo_6049" data-name="Grupo 6049" transform="translate(8.707 4.707) rotate(180)">
                                    <line id="Línea_794" data-name="Línea 794" x2="4" y2="4" transform="translate(4)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                                    <line id="Línea_795" data-name="Línea 795" x1="4" y2="4" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                                </g>
                                </svg>
                            </button>
                        </div>

                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body" style="padding-top:0px;">
                                <FormDynamic
                                    :form_format="form_format_advanced_search"
                                    :form_data="form_data_advanced_search"
                                    :array_options="array_options"
                                    :for_update="false"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-show="rooms.length">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="rooms || []"
                                :search="search"
                                name="template_update_modal"
                                ref="template_update_modal"
                                :checkable="true"
                            />
                        </v-card>
                    </div>
                </div>

                <LocalCentralButtons
                    :modal_name="'static-template'"
                    :save_view="save_view"
                    @saveView="save_and_view($event)"
                />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources            from    './form_resources'
import FormDynamic              from    '@/components/FormDynamic.vue'
import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal                from    '@/components/BaseModal'
import LocalCentralButtons      from    './LocalCentralButtons'
import DinamicTable             from    '@/components/DinamicTable'

export default {

    name:   'FormModal',
    props: [
        "title",
        "rest_api",
        "notyf",
        "array_options",
        "breadcrumb",
        "save_view",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        LocalCentralButtons,
        DinamicTable
    },

    data(){
        return{
            levels: [],
            areas: [],
            form_data: FormResources.form_data_template,
            form_backup: {...FormResources.form_data_template},
            form_format: FormResources.form_format_template,
            form_format4: FormResources.form_format4,

            form_data_advanced_search: FormResources.form_data_advanced_search,
            form_format_advanced_search: FormResources.form_format_advanced_search,

            rooms:              [],
            search:             '',
            table_selection:    [],

            table_headers: [
                { 
                  text:     '# Room',
                  align:    'start', 
                  value:    'door_number'
                },
                { 
                  text:     'Description',
                  value:    'description'
                },
                { 
                  text:     'Walking #',
                  value:    'walking_number'
                },
            ],
        }
    },

    computed: {
        display_rooms()
        {
            return this.rooms
        }
    },

    watch:{

        'form_data.omission_setting'(val){
            if(val < 1)
            {
                this.form_data.omission_setting = 1
            }
            else if(val > 90)
            {
                this.form_data.omission_setting = 90
            }
        },

        async 'form_data_advanced_search.building_id'(val){
            if (!this.form_data.room_type_id.length)
            {
                this.notyf.error('Select a Room type')
                return false
            }

            if (this.form_data.inspection_template_id === '')
            {
                this.notyf.error('Select a Template')
                return false
            }
            if(val)
            {
                this.loader(true)
                let http_request = {
                    levels_areas: true,
                    building_id: val,
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    this.filtering_data()
                    if(response.data.levels.length)
                    {
                        this.array_options.level_id = response.data.levels
                        this.form_data_advanced_search.level_id = ''
                        this.notyf.success('Levels available')

                    }
                    else
                    {
                        this.array_options.level_id = []
                        this.form_data_advanced_search.level_id = ''
                        this.notyf.error('No Levels available')
                    }
                    this.array_options.area_id = []
                    this.form_data_advanced_search.area_id = ''

                    this.loader()
                }
                else
                {
                    this.error_handling(response)
                    this.loader()
                }
            }
        },

        async 'form_data_advanced_search.level_id'(val){
            if (!this.form_data.room_type_id.length)
            {
                this.notyf.error('Select a Room type')
                return false
            }

            if (this.form_data.inspection_template_id === '')
            {
                this.notyf.error('Select a Template')
                return false
            }
            if(val)
            {
                this.loader(true)
                let http_request = {
                    levels_areas: true,
                    level_id: val,
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    this.filtering_data()
                    if(response.data.areas.length)
                    {
                        this.array_options.area_id = response.data.areas
                        this.form_data_advanced_search.area_id = ''
                        this.notyf.success('Areas available')

                    }
                    else
                    {
                        this.array_options.area_id = []
                        this.form_data_advanced_search.area_id = ''
                        this.notyf.error('No Areas available')
                    }

                    this.loader()
                }
                else
                {
                    this.error_handling(response)
                    this.loader()
                }
            }
        },

        async 'form_data_advanced_search.area_id'(val){
            if(val)
            {
                this.filtering_data()
            }
        },

        async 'form_data.inspection_template_id'(val)
        {
            this.form_data.room_type_id = []
            
            if(val)
            {
                let http_request = {
                    inspection_template_id: val,
                    room_types: true,
                }

                this.loader(true)

                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)
                if(response.status)
                {
                    if(response.data.room_types.length)
                    {
                        this.array_options.room_type_id = response.data.room_types
                        this.notyf.success('Room Types Available')
                    }
                    else
                    {
                        this.array_options.room_type_id = []
                        this.notyf.error('Room Types no data available')
                    }
                }
                else
                {
                    this.error_handling(response)
                }

                this.loader()
            }
        },

        rooms(val)
        {
            if(!val.length)
            {
                this.form_data_advanced_search.building_id = ''
                this.form_data_advanced_search.level_id = ''
                this.form_data_advanced_search.area_id = ''
                this.array_options.level_id = []
                this.array_options.area_id = []
            }
        }

    },

    methods:{

        async filtering_data()
        {
            if (!this.form_data.room_type_id.length)
            {
                this.notyf.error('Select a Room type')
                return false
            }

            if (this.form_data.inspection_template_id === '')
            {
                this.notyf.error('Select a Template')
                return false
            }
            
            if (this.form_data.random_room && this.form_data.room_count < 1)
            {
                this.notyf.error('# Rooms cannot be empty')
                return false
            }

            let http_request = {
                room_type_id: this.form_data.room_type_id,
                room_request: true,
                exclude_rooms: this.form_data.exclude_rooms,
                omission_setting: this.form_data.omission_setting,
                random_room: this.form_data.random_room,
                room_count: parseInt(this.form_data.room_count),
                building_id: this.form_data_advanced_search.building_id,
                level_id: this.form_data_advanced_search.level_id,
                area_id: this.form_data_advanced_search.area_id,
            }


            this.loader(true)
            const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)

            if(response.status)
            {
                if(response.data.rooms.length)
                {
                    this.rooms = response.data.rooms
                    this.table_selection = []
                    this.notyf.success('Rooms available')
                }
                else
                {
                    this.rooms = []
                    this.notyf.error('No Rooms available')
                }
                this.loader()
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        form_submit_simulated()
        {
            let checked_rooms = this.rooms.filter(item => item.checked)
            if(!checked_rooms.length)
            {
                this.notyf.error('You must select at least a room to continue')
                return false
            }

            this.form_data.room_ids = checked_rooms.map(item => item.id)

            this.form_submit('static-template', {inspection_type_id: 2, ...this.form_data})
            this.rooms = []
        },

        save_and_view(event)
        {
            this.$emit('saveView', event)
        },
    },

    mounted()
    {
        this.form_data.date = this.currentDateToString()
        this.form_backup.date = this.currentDateToString()
    }
    
}
</script>